import { getObjectUtil } from 'packages/src'

function getCurrentReduxSelector (domainMapPath, domainCurrentPath) {
  return state => (
    getObjectUtil(state, `${domainMapPath}.${getObjectUtil(state, domainCurrentPath)}`)
  )
}

export default getCurrentReduxSelector
